import type { Dictionnaire } from '../type';

export const appels: Dictionnaire['appels'] = {
  erreurs: {
    camera: 'Sirocco no tiene acceso a tu cámara.',
    micro: 'Sirocco no tiene acceso a tu micrófono.',
    connexion: 'No se ha podido establecer la conexión. Inténtalo desde otra red.',
    compteOfficiel: 'La cuenta de la aplicación no recibe llamadas. Escríbele.',
    pasAmi: 'Solo puedes llamar a tus amigos. Añade antes a este miembro.',
    pasAbouti: 'La llamada no ha podido realizarse.',
    nExistePlus: 'Esta llamada ya no existe.',
  },
  natif: {
    pasAbouti: 'La llamada no ha podido realizarse.',
  },
  ecran: {
    quelquun: 'Alguien',
    personneNaRepondu: 'Nadie ha respondido.',
    pasParti: 'La llamada no ha podido salir.',
    pasAbouti: 'La llamada no ha podido realizarse.',
    echanger: 'Intercambiar las dos imágenes',
    reduire: 'Minimizar la llamada',
    appel: 'Llamada',
    connexion: 'Conectando…',
    appelVideo: 'Videollamada…',
    appelEnCours: 'Llamando…',
    refuser: 'Rechazar',
    repondreVideo: 'Responder con vídeo',
    repondre: 'Responder',
    accepter: 'Aceptar',
    reactiverMicro: 'Activar el micrófono',
    couperMicro: 'Silenciar el micrófono',
    montrerCamera: 'Mostrar mi cámara',
    cameraPasOuverte: 'No se ha podido abrir la cámara.',
    rallumerCamera: 'Volver a encender mi cámara',
    couperCamera: 'Apagar mi cámara',
    ecouteur: 'Volver al auricular',
    hautParleur: 'Pasar al altavoz',
    raccrocher: 'Colgar',
    entrant: { video: 'Videollamada entrante…', audio: 'Llamada entrante…' },
    son: (detail: string) => `Sonido: ${detail}`,
    natifMuet: 'la capa nativa no responde',
  },
};
